import { useEffect, useRef, useState } from 'react';
import './App.css';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Header from './components/Header/Header';
import Projects from './pages/Projects/Projects';
import ActionForm from './pages/ActionForm/ActionForm';
import Footer from './components/Footer/Footer';
import { getMainPageData2, getMunicForm } from './utils/apiUtils';
import { getTableRowsReady2 } from './utils/externalFunc';
import { useDispatch, useSelector } from 'react-redux';
import { setFleg, setLocationIdent } from './store/YamatReducer';
import ErrorPage from './pages/404/404';
import { isDesktop } from 'react-device-detect';
import MobileAlert from './pages/MobileAlert/MobileAlert';

function App() {

  const store = useSelector(state => state.reducer)
  const [mainDataObj, setMainDataOb] = useState(false)
  const [projectTableRows, setProjectTableRows] = useState(false)
  const [filterValues, setFilterValues] = useState({})
  const [extraData, setExtraData] = useState({})
  const leadColor = "#b60072"
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  let locationIdent = location.pathname.split("/")
  let locationIdentValue = "";

  let finalMount = useRef(true);
  useEffect(() => {
      if(finalMount.current){
        finalMount.current = false 
        if(locationIdent.length > 0 && isDesktop){
            locationIdentValue = locationIdent[1]
            dispatch(setLocationIdent(locationIdentValue))
        }     
      }
  },[])

  useEffect(() => {
    locationIdentValue && getMainObjData()
  }, [locationIdentValue])
  
  const getMainObjData = () => {
      dispatch(setFleg({key: 'initial', value: true}))

      // Fetch both the main data and the form data (which contains extraData)
      Promise.all([
        getMainPageData2(locationIdentValue || store.locationIdent),
        getMunicForm()
      ])
      .then(([mainDataRes, formDataRes]) => {
        setMainDataOb(mainDataRes.data)

        // Extract extraData from the form response
        const formExtraData = formDataRes.data.extraData || {}
        setExtraData(formExtraData)

        // Pass extraData to getTableRowsReady2
        let rowsObj = getTableRowsReady2(mainDataRes.data.projects, formExtraData)
        setFilterValues(rowsObj.finalFilters)
        setProjectTableRows(rowsObj.finalRows)
        dispatch(setFleg({key: 'connected', value: true}))
      })
      .catch(() => {
          navigate("/404")
      })
  }

  return (
    <div className="App f-reg">
      {mainDataObj && <Header mainDataObj={mainDataObj}/>}
      
      {isDesktop && <Routes>                     
                        <Route path='/*' element={<ErrorPage/>} />
                        <Route path='/:locationCode' element={<Projects leadColor={leadColor} projectTableRows={projectTableRows} mainDataObj={mainDataObj} filterValues={filterValues} getMainObjData={getMainObjData} type={mainDataObj.municipality?.link?.status === 'active' ? 'projects' : 'closed'}/>} />  
                        <Route path='/:locationCode/projects' element={<Projects leadColor={leadColor} projectTableRows={projectTableRows} mainDataObj={mainDataObj} filterValues={filterValues} getMainObjData={getMainObjData} type={mainDataObj.municipality?.link?.status === 'active' ? 'projects' : 'closed'}/>} />  
                        <Route path='/:locationCode/archive' element={<Projects leadColor={leadColor} projectTableRows={projectTableRows} mainDataObj={mainDataObj} filterValues={filterValues} type="archive"/>} />
                        <Route path='/:locationCode/action-form' element={<ActionForm getMainObjData={getMainObjData} leadColor={leadColor} mainDataObj={mainDataObj}/>} />
                        <Route path='/:locationCode/action-form/:id' element={<ActionForm getMainObjData={getMainObjData} leadColor={leadColor} mainDataObj={mainDataObj}/>} />
                    </Routes>}
      {mainDataObj && <Footer mainDataObj={mainDataObj}/>}
      {!isDesktop && <MobileAlert/>}
    </div>
  );
}

export default App;
